import { LocalStorage } from 'common/Storage';

import type { IConfig } from 'types';

export function isFeatureEnabled(config: IConfig, feature: string) {
  const { featureFlags = {} } = config || {};
  return !!LocalStorage.get(feature) || !!featureFlags[feature];
}
